import React from 'react';
import { View } from 'react-native';

import { useThemedStyles } from '../../hooks/useThemedStyles';
import Text from '../text/Text';

export const Label = ({
	label,
	style,

	primary,
	secondary,
	grey,
	accent,
	red,
	yellow,
	green,
	darkGrey,
	darkGreyMild,

	labelContainerDark,
}) => {
	const styles = useThemedStyles(createStyles);

	return (
		<View style={[
			labelContainerDark && styles.labelContainerDark || styles.labelContainer,
			primary && styles.primary,
			secondary && styles.secondary,
			grey && styles.grey,
			darkGrey && styles.darkGrey,
			darkGreyMild && styles.darkGreyMild,
			accent && styles.accent,
			red && styles.red,
			yellow && styles.yellow,
			green && styles.green,
			style,
		]}>
			<Text style={[
				styles.labelText,
				primary && styles.primaryText,
				secondary && styles.secondaryText,
				grey && styles.greyText,
				darkGrey && styles.darkGreyText,
				darkGreyMild && styles.darkGreyMildText,
				accent && styles.accentText,
				red && styles.redText,
				yellow && styles.yellowText,
				green && styles.greenText,
			]}>
				{label}
			</Text>
		</View>
	);
};

// Tones map onto the redesign tag colours; the props stay as before.
const createStyles = ({ ui: { colors, radius, type } }) => ({
	labelContainer: {
		borderWidth: 1,
		borderRadius: radius.tag,
		paddingVertical: 2,
		paddingHorizontal: 7,
		marginRight: 2,
		marginLeft: 2,
		alignSelf: 'flex-start',
		borderColor: colors.tag,
		backgroundColor: colors.tag,
	},
	labelContainerDark: {
		borderWidth: 1,
		borderRadius: radius.tag,
		paddingVertical: 2,
		paddingHorizontal: 7,
		marginRight: 2,
		marginLeft: 2,
		alignSelf: 'flex-start',
		borderColor: colors.borderStrong,
		backgroundColor: colors.card,
	},
	labelText: {
		...type.tag,
		color: colors.onChip,
	},
	greyText: {
		color: colors.textSecondary,
	},
	grey: {
		borderColor: colors.border,
		backgroundColor: colors.card,
	},
	darkGreyText: {
		color: colors.textSecondary,
	},
	darkGrey: {
		borderColor: colors.borderStrong,
		backgroundColor: colors.card,
	},
	darkGreyMild: {
		borderColor: colors.border,
		backgroundColor: 'transparent',
	},
	darkGreyMildText: {
		color: colors.textFaint,
	},
	primary: {
		borderColor: colors.chip,
		backgroundColor: colors.chip,
	},
	primaryText: {
		color: colors.accent,
	},
	secondary: {
		borderColor: colors.warningTagBg,
		backgroundColor: colors.warningTagBg,
	},
	secondaryText: {
		color: colors.warning,
	},
	accent: {
		borderColor: colors.successBg,
		backgroundColor: colors.successBg,
	},
	accentText: {
		color: colors.onSuccessBg,
	},
	red: {
		borderColor: colors.dangerBorder,
		backgroundColor: colors.dangerBg,
	},
	redText: {
		color: colors.danger,
	},
	yellow: {
		borderColor: colors.warningBorder,
		backgroundColor: colors.warningBg,
	},
	yellowText: {
		color: colors.warning,
	},
	green: {
		borderColor: colors.successBg,
		backgroundColor: colors.successBg,
	},
	greenText: {
		color: colors.onSuccessBg,
	},
});
